<!-- <div class="flex justify-content-end flex-wrap card-container">
    <button type="button" class="btn btn-box-tool" data-widget="collapse">
    <i class="fa fa-minus"></i>
  </button>
</div> -->
<!-- Update 01/04/22 -->
<div class="grid table-demo">
  <div class="col-12">
    <div class="card mt-2">
      <h5>{{ title }}</h5>
      <div id="p-chart" echarts [options]="optionsCharts()" [merge]="updateOptions()">

      <!-- <div id="p-chart"> -->
        <!-- <dx-chart
          [dataSource]="tracesByMonth"
          title="{{ headerName | translate }}"
        >
          <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
          <dxi-series
            valueField="data"
            name="{{ statusOptionName | translate }}"
            color="#00c0ef"
          ></dxi-series>
          <dxi-series
            valueField="dataSecond"
            name="{{ statusSecondOptionName | translate }}"
            color="#f39c12"
          ></dxi-series>
          <dxo-common-series-settings
            #seriesSettings
            argumentField="month"
            [type]="'spline'"
          >
          </dxo-common-series-settings>
          <dxo-margin [bottom]="20"></dxo-margin>
          <dxo-common-axis-settings>
            <dxo-grid [visible]="true"></dxo-grid>
          </dxo-common-axis-settings>
          <dxo-legend verticalAlignment="top" horizontalAlignment="right">
          </dxo-legend>
          <dxo-argument-axis [allowDecimals]="false" [axisDivisionFactor]="60">
            <dxo-label>
              <dxo-format type="decimal"></dxo-format>
            </dxo-label>
          </dxo-argument-axis>
          <dxo-export [enabled]="true"></dxo-export>
          <dxo-tooltip [enabled]="true"></dxo-tooltip>
        </dx-chart> -->
      <!-- </div> -->
    </div>
  </div>
</div>
